import hellojs from '../../vendor/hello.js'

export default function () {
  return hellojs
    // install RocketMatter driver
    .init({
      rocketmatter: {
        name: 'Rocket Matter',

        base: 'https://www.rocketmatter.net/public/',

        oauth: {
          version: 2,
          auth: 'https://www.rocketmatter.net/public/AuthenticationStart.aspx',
          // NOTE
          // This grant URL wont work, but Hello.js requires a grant url to be defined for 'code' response type
          // to be used, so just use a dummy URL here.  OAuth Proxy figures out the right URL for us
          grant: 'https://www.rocketmatter.net/api_v2/Authentication.svc/json/GrantToken',
          response_type: 'code',
        },

        scope: [],
      }
    })
    // Initialize Driver instance
    .init(
      { rocketmatter: window.Drupal.settings.INTEGRATIONS_ROCKETMATTER_APP_ID },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy/rocket-matter`,
      }
    )('rocketmatter'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/RocketMatterAuthenticator.js